export default __webpack_public_path__ + "static/media/SendCodeIllustrator.4b8edcc0.svg";